import React, { useEffect, useState } from "react";
import { fetchReportTasks } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface TasksCompletedMetricState {
  data?: any[];
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
}

export const TasksCompletedMetric = ({ data, useDatePicker = false, startDate, endDate }: TasksCompletedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [completed, setCompleted] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setCompleted(data.toString());
        setIsLoading(false);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getTaskData(start!, end!);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getTaskData = async (start: string, end: string) => {
    fetchReportTasks(start, end)
      .then((res: any) => {
        const data = res[0].data;
        setCompleted(data.length.toString());
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return <SingleCardMetric title={"Tasks Completed"} total={completed} isLoading={isLoading} />;
};
